export default __webpack_public_path__ + "static/media/norquant_logo_black_text.069109c9.svg";